import { ProfileName } from '@constants/integrations';
import {
    YelpIcon,
    FacebookIcon,
    GoogleIcon,
    TrustpilotIcon,
    TripAdvisorIcon,
    BookingIcon,
    IFoodIcon,
    TheForkIcon,
    DeliverooIcon,
    HotelsIcon,
    ExpediaIcon,
    HealthgradesIcon,
    ZocdocIcon,
    RateMDsIcon,
    UberEatsIcon,
    BbbIcon,
} from 'assets/images/integrations';

export const getIntegrationIcon = type => {
    switch (type) {
        case ProfileName.Yelp:
            return <YelpIcon />;
        case ProfileName.Facebook:
        case ProfileName.FacebookOfficial:
            return <FacebookIcon />;
        case ProfileName.Google:
        case ProfileName.GoogleOfficial:
            return <GoogleIcon />;
        case ProfileName.Trustpilot:
            return <TrustpilotIcon />;
        case ProfileName.TripAdvisor:
            return <TripAdvisorIcon />;
        case ProfileName['Booking.com']:
            return <BookingIcon />;
        case ProfileName.TheFork:
            return <TheForkIcon />;
        case ProfileName.Deliveroo:
            return <DeliverooIcon />;
        case ProfileName.iFood:
            return <IFoodIcon />;
        case ProfileName['Hotels.com']:
            return <HotelsIcon />;
        case ProfileName.Expedia:
            return <ExpediaIcon />;
        case ProfileName.Healthgrades:
            return <HealthgradesIcon />;
        case ProfileName.Zocdoc:
            return <ZocdocIcon />;
        case ProfileName.RateMDs:
            return <RateMDsIcon />;
        case ProfileName.UberEats:
            return <UberEatsIcon />;
        case ProfileName.BBB:
            return <BbbIcon />;
        default:
            return null;
    }
};

// Canonical "is this account-level integration type connected" check. An account can have several
// integrations of the same type (and inactive/auth-disabled rows are still returned by the API), so
// presence is NOT connection — only an ACTIVE row counts. Use this everywhere instead of
// `account.integrations.find(i => i.type === ...)`, which treats any row as connected and can be
// masked by an earlier inactive sibling.
export const isIntegrationConnected = (account, type) =>
    !!account?.integrations?.some(i => i.type === type && i.isActive);

// Pending implies active — the backend only derives it for active rows, so any UI branch that
// distinguishes the two must test pending first.
export const isIntegrationPending = (account, type) =>
    !!account?.integrations?.some(i => i.type === type && i.isPending);

// All ACTIVE integrations of a type on the account (an account can have several). Empty array if none.
// Use this instead of an ad-hoc `account.integrations.filter(i => i.type === ...)`.
export const getActiveIntegrations = (account, type) =>
    account?.integrations?.filter(i => i.type === type && i.isActive) ?? [];

// i18n key for a LinkedIn publish target's type (personal member vs administered Page). Returns the
// key so callers translate it themselves — keeps this pure and avoids threading `t` through utils.
export const linkedinTargetLabelKey = type =>
    type === 'organization' ? 'SettingsCompanies.linkedinPage' : 'SettingsCompanies.linkedinPersonal';
